export default __webpack_public_path__ + "static/illustration-f71a28bd1a026de8e7c8124d2682ad00.svg";